module.exports = __webpack_public_path__ + "static/img/cara-001.53dda43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cara-001.svg
// module id = ovgd
// module chunks = 1